import { useEffect, useState } from "react";
import { Hero } from "@/components/ui/animated-hero";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { AuthButtons } from "@/components/blocks/auth-buttons";
import { MainContentSection } from "@/components/blocks/main-content-section";
import { PlatformPreview } from "@/components/blocks/platform-preview";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_IN") {
        checkAuth();
      } else if (event === "SIGNED_OUT") {
        setIsAuthenticated(false);
        setIsAdmin(false);
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  const checkAuth = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        setIsAuthenticated(true);
        const { data: profile } = await supabase
          .from("profiles")
          .select("is_admin")
          .eq("id", session.user.id)
          .single();
        setIsAdmin(profile?.is_admin || false);
      }
    } catch (error) {
      console.error("Error checking auth:", error);
      toast({
        title: "Error",
        description: "Failed to check authentication status",
        variant: "destructive",
      });
    }
  };

  const handleSignOut = async () => {
    try {
      await supabase.auth.signOut();
      toast({
        title: "Signed out successfully",
      });
    } catch (error) {
      console.error("Error signing out:", error);
      toast({
        title: "Error",
        description: "Failed to sign out",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <AuthButtons 
        isAuthenticated={isAuthenticated}
        isAdmin={isAdmin}
        onSignOut={handleSignOut}
      />
      <div className="space-y-24 sm:space-y-28 md:space-y-36">
        <Hero onOpenWaitlistModal={() => navigate('/waitlist')} />
        <PlatformPreview />
        <MainContentSection />
      </div>
    </div>
  );
};

export default Index;